'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = CancelOfferPlanDescription;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _kite = require('./assets/kite.svg');

var _kite2 = _interopRequireDefault(_kite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function CancelOfferPlanDescription(p) {

    var planName = p.currentPlanInfo.name;
    var calloutText = 'If you downgrade, you\'ll miss out on these great ' + planName + ' features:';

    var callout = _react2['default'].createElement(
        'div',
        { className: 'm-cancel-offer-plan-description--callout' },
        calloutText
    );

    var planFeatures = p.offerPlanInfo.features;
    var features = _react2['default'].createElement(
        'ul',
        null,
        planFeatures.map(function (feat, index) {
            return _react2['default'].createElement(
                'li',
                { key: 'feature-' + index },
                feat
            );
        })
    );

    var readMoreLink = _react2['default'].createElement(
        'a',
        { href: '/info/tour' },
        'Read more about our features.'
    );

    var imageStyle = { marginTop: -5, marginLeft: -15 };
    var kiteImage = _react2['default'].createElement('img', { src: _kite2['default'], style: imageStyle });

    return _react2['default'].createElement(
        'div',
        { className: 'm-cancel-offer-plan-description' },
        callout,
        features,
        readMoreLink,
        kiteImage
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/customer-cancel-offer/cancel-offer-plan-description.jsx
 ** module id = 1039
 ** module chunks = 0
 **/